// Requires: src/namespace.js
// Requires: src/register-product.sectionManager.js
// Requires: src/register-product.serialErrorManager.js
// Requires: src/register-product.showStepOneButtons.js

window.BOL.myProduct = (function($, serialErrorManager, stepButtons, sectionManager) {
	"use strict";

	var ATTRIBUTES = {
		productCardID: 'data-product-id',
		myProductsID:  'data-my-products-id',
		myProducts:    'data-my-products-has-products',
		delete:        'data-my-products-remove-item',
		template:      'data-my-product-clone',
		hasPromo:      'data-my-products-haspromo',
		promo:         'data-my-products-promo'
	};

	var SELECTORS = {
		productCardID: '[' + ATTRIBUTES.productCardID + ']',
		myProductsID:  '[' + ATTRIBUTES.myProductsID + ']',
		myProducts:    '[' + ATTRIBUTES.myProducts + ']',
		template:      '[' + ATTRIBUTES.template + ']',
		delete:        '[' + ATTRIBUTES.delete + ']',
		promo:         '[' + ATTRIBUTES.promo + ']',
		image:         '[data-my-products-image]',
		modalName:     '[data-my-products-model-name]',
		serialNumber:  '[data-my-products-serial-number]',
		container:     '[data-my-products-container]',
		modalDelete:   '[data-product-modal-delete]'
	};

	var DELETE_URL = '/api/sitecore/SerialNumber/Delete';

	var myProducts   = $(SELECTORS.myProductsID);
	var $deleteLinks = $(SELECTORS.delete);
	var $modalDelete = $(SELECTORS.modalDelete);
	var $myProducts  = $(SELECTORS.myProducts).eq(0);
	var $container   = $(SELECTORS.container).eq(0);

	var template;
	var productToDeleteSerial;
	var productToDeleteModel;
	var products = {};

	function toggleNoProductsMessage() {
		if(Object.keys(products).length > 0) {
			// Hide the no products message
			$myProducts.attr(ATTRIBUTES.myProducts, true);
		} else {
			// Show the no products message
			sectionManager.reset(false, true);
			stepButtons.toggleButtons(false);
			$myProducts.attr(ATTRIBUTES.myProducts, false);
		}
	}

	function addIDToModal(event) {
		// Sets this to the current selected serial so when it is deleted we know which product to delete.
		productToDeleteSerial = event.data.serial;
	}

	function removeCurrentProduct() {
		// Removes the product that has that serial
		$('[' + ATTRIBUTES.myProductsID + '="'+ productToDeleteSerial +'"]').eq(0).remove();

	    delete products[productToDeleteSerial];

		toggleNoProductsMessage();
	}

	function handleModalDeleteEvent(event) {
	    event.preventDefault();

		if(productToDeleteSerial) {
		    $.post(DELETE_URL, { id: productToDeleteSerial })
				.done(function(response){
					if(!response.error) {
						// Product removed, clear it from the list
						removeCurrentProduct(event.target);
					} else {
						// Adding the product failed show the error page
						serialErrorManager.showError(response.error.message);
					}
				})
				// Deal with the request failing
				.fail(function() {
					serialErrorManager.showError();
				});
		}
	}

	function bindEventToEl(el, data) {
		// Attach an event to the close so it will add the serial to the delete button thats inside the modal when clicked.
		el.on('click', data, addIDToModal);
	}

	function setUpExistingProduct(deleteLink) {
		var productData = {
			serial: deleteLink.attr(ATTRIBUTES.delete)
		};

		bindEventToEl(deleteLink, productData);
	}

	function restoreProduct(index, currentProduct) {
		var el = $(currentProduct);
		var id = $.trim(el.attr(ATTRIBUTES.myProductsID));
		if (id !== '') {
			addToProductObject(el, { productId: id });
			setPromoVisibility(id, el.attr(ATTRIBUTES.hasPromo) == 'true');
		}
	}

	function init() {
		var i;

		for(i = 0; i < $deleteLinks.length; i++) {
			setUpExistingProduct($deleteLinks.eq(i));
		}

		$modalDelete.on('click', handleModalDeleteEvent);

		$.each(myProducts, restoreProduct);
	}

	function prepareTemplate() {
		// Don't bother setting it up again if we already have before
		if(typeof template === 'undefined') {
			template = {};
			// Store a reference to the template element
			template.element = $(SELECTORS.template).eq(0).clone();

			// Store references to the parts of the template we are going to update
			template.model = template.element.find(SELECTORS.modalName).eq(0);
			template.serial = template.element.find(SELECTORS.serialNumber).eq(0);
			template.image  = template.element.find(SELECTORS.image).eq(0);
			template.delete = template.element.find(SELECTORS.delete).eq(0);

			// Strip the attribute that specifies this is a template
			template.element.removeAttr(ATTRIBUTES.template);
		}
	}

	function setTemplateData(productData) {
		// Create the base template
		prepareTemplate();

		// Set the serial on the container
		template.element.attr(ATTRIBUTES.myProductsID, productData.productId);
		// Set the model name
		template.model.text(productData.model);
	    // Set the serial number
	    template.serial.text(productData.serial);
		// Add the serial to the delete button
		template.delete.attr(ATTRIBUTES.delete, productData.productId);
		// Set the image values
		template.image.attr({
			src: productData.image,
			alt: productData.model
		});
	}

	function addDeleteEventHandler($productElement, productData) {
		var $delete = $productElement.find(SELECTORS.delete).eq(0);

		// Attach an event to the close so it will add the serial to the delete button thats inside the modal when clicked.
		bindEventToEl($delete, {serial: productData.productId});
	}

	function addProductToContainer(productData) {
		var $product = template.element.clone();

		addDeleteEventHandler($product, productData);
		$container.append($product);

		return $product;
	}

	function addToProductObject($element, productData) {
		products[productData.productId] = {
			element: $element,
			promo:   $element.find(SELECTORS.promo).eq(0)
		};
	}

	function add(productData) {
		var $product;

		setTemplateData(productData);
		$product = addProductToContainer(productData);
		addToProductObject($product, productData);
		toggleNoProductsMessage();
	}

	function remove(serialNo, model) {
		// Need to set the current product and trigger the modal
		productToDeleteSerial = serialNo;
		productToDeleteModel = model;
		removeCurrentProduct();
	}

	function isSerialRegistered(productSerial) {
		return Object.keys(products).length  > 0 && products.hasOwnProperty(productSerial);
	}

	function setPromoVisibility(productId, isVisible) {
		if(isSerialRegistered(productId) && isVisible) {
			products[productId].promo.show();
		} else {
			products[productId].promo.hide();
		}
	}

	function addPromo(productId) {
		setPromoVisibility(productId, true);
	}

	function removePromo(productId) {
		setPromoVisibility(productId, false);
	}

	init();

	return {
		add:         add,
		remove:      remove,
		addPromo:    addPromo,
		removePromo: removePromo,
	};

})($jq, window.BOL.RegisterProduct.serialErrorManager, window.BOL.RegisterProduct.showStepOneButtons,  window.BOL.RegisterProduct.sectionManager);
